<template>
  <div class="quiz-container">
     
    <div class="quiz-header is-vcentered">
         <figure class="image awsLogo rounded">
          <img class="is-rounded imageWidth" :src="logo" />
        </figure>
      <div class="header has-text-weight-bold" :style="quizMessage">
        {{quizName}}
        </div>
    </div>
    <div class="quiz-instructions">
      <div class="box" :style="boxSettings">
        <div class="tile is-size-3" :style="quizMessage" >Instructions</div>
        <hr :style="hrMargin" />
        <span class="mt-2 is-size-7-mobile is-size-6-tablet pointers" :style="quizLoginSettings" v-html="instructions"></span>
        <div class="is-size-6-mobile is-size-4-tablet has-text-centered mt-2"  :style="quizMessage" > That's it! Here you go!! </div>
        <div class="center mt-4">
          <button
          :style="buttonSettings"
            class="button"
            @click="accept"
          >start</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Instructions',
  methods: {
    accept() {
      this.$store.dispatch('readInstructions');
    },
  },
   computed: {
    ...mapGetters([
      'instructions', 'quizName', 'logo', 'backgroundColor', 'primaryColor', 'textColor'
    ]),
    hrMargin(){
      return{
        "background-color": this.primaryColor
      }

    }, 
     boxSettings(){
      return{
        "background-color": this.backgroundColor,
      }
    },
    buttonSettings(){
      return{
        "background-color": this.primaryColor,
        "border-color": this.primaryColor,
        "color": this.textColor
      }
    },
    quizLoginSettings(){
      return{
        "color": this.textColor
        
      }
    },
    quizMessage(){
      return{
        "color": this.primaryColor
        
      }
    }
  },
};
</script>

<style lang="scss" scoped>

.quiz-container {
  width: 100vw;
  height: 100vh;
  background-color: $app-background-color;
  overflow: auto;

  .textColor{
    color: $primary-color;
  }

  .awsLogo{
    width: 125px;
    align-items: initial;
    margin-top: 32px;

    .imageWidth{
          width: 125px;
          height: 100px;
        }
  }

  .quiz-header {
    display: flex;
    justify-content: center;

    .header {
      font-size: 48px;
      line-height: 40px;
      color: $primary-color;
      padding: 4rem;
      margin-top: 10px
    }
    .timmer {
      font-size: 64px;
      line-height: 40px;
      color: $primary-color;
      padding: 4rem;
    }
  }

  .quiz-instructions {
    display: flex;
    justify-content: center;

    .box {
      background-color: $box-background-color;
      border-radius: 1.56rem;
      padding: 15px;
      max-width: 80rem;
      width: 80rem;
      min-height: 25rem;
      //max-height: 25rem;
      display: grid;
      flex-direction: column;
      flex-grow: 0;
      align-items: unset;

      .tile {
        font-weight: bold;
        line-height: 40px;
        color: $primary-color;
        padding: 0.5rem;
        max-height: 4rem;
        overflow: hidden;
        display: flex;
        align-self: center;
      }
      hr {
        background-color: $primary-color;
        border-radius: 25px;
        margin: 0rem;
      }
      ol {
        list-style: none;
        counter-reset: my-awesome-counter;
        max-height: 16rem;
        color: $brand-color;
        overflow-y:auto;

        li {
          counter-increment: my-awesome-counter;
          display: flex;

          &:before {
            content: counter(my-awesome-counter)".";
            width:1.5rem;
            padding-right: 4px;
            text-align: right;
          }
        }
      }
      .pointers{
    padding: 20px;
    color: white;
    font-size: 18px !important;
    margin-top: 10px;
      }
      .center {
        display: flex;
        justify-content: center;
        &:focus {
          border: 1px solid $primary-color;
        }
        .button {
          border-radius: 20px;
          font-weight: 600;
          font-size: 16px;
          text-transform: uppercase;
          &:hover {
            color: $white;
          }
        }
      }
    }
  }
}
</style>
